var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{attrs:{"label":_vm.$t('Upload Document')}},[_c('custom-image-upload',{attrs:{"height":"220","pdf-allowed":true,"title":_vm.$t('Document')},on:{"imageUploaded":(img,url) => _vm.$emit('document-uploaded', url),"imageRemoved":() => _vm.$emit('document-removed')}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }